import { Standard } from '@getvim/vim-connect';

const demographics: Standard.Entities.PatientDemographics = {
  firstName: 'John',
  lastName: 'Smith',
  dateOfBirth: '1988-03-15',
  address: {
    zipCode: '90001',
  },
};

const insurance: Standard.Entities.PatientInsurance = {
  memberId: '100000001',
  ehrInsurance: 'mock-payer',
};

const patientId: string = 'test_mock-payer_20260212120644';

export const johnSmith: Standard.Events.PatientInContextPayload = {
  patientId,
  demographics,
  insurance,
};
